<template>
  <a-layout v-if="!islogin" :style="{ height: '100%' }">
    <a-form class="login_form">
      <img src="com.png" class="login_form_logo" />
      <h3 class="login_form_title">Comerge Vessel Accounting System</h3>
      <a-form-item>
        <a-input v-model="username" placeholder="Username">
          <a-icon slot="prefix" type="user" style="color: rgba(0, 0, 0, 0.25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input
          v-model="password"
          type="password"
          placeholder="Password"
          @keyup.enter="login"
        >
          <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, 0.25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="login" class="login-form-button"
          >Log in</a-button
        >
      </a-form-item>
    </a-form>
  </a-layout>

  <a-layout v-else :style="{ height: '100%' }">
    <a-layout-sider>
      <div class="logo" />
      <a-menu theme="dark" mode="inline" :defaultSelectedKeys="['4']">
        <a-menu-item
          v-for="(m, idx) in menu.find((m) => m.name == userinfo.group).menus"
          :key="idx"
        >
          <router-link tag="a" :to="m.to">
            <a-icon :type="m.icon" />
            <span class="nav-text">{{ m.title }}</span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="logout" @click="logout">
          <a-icon type="export" />
          <span class="nav-text">Logout</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-content
        :style="{ margin: '20px 16px 20px 16px', height: '2800px', position: 'relative' }"
      >
        <div :style="{ padding: '24px', background: '#fff', minHeight: '100%' }">
          <router-view></router-view>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import userinfo from "./utils/userinfo.js";
import menu from "./utils/menu.js";

export default {
  data() {
    return {
      v: 2,
      k: "f534bb6699234c8ab36061a4ea5b0058",
      kw: "XING DE HAI",

      username: "",
      password: "",
      userinfo: userinfo.get(),
      islogin: this.$isLogin,

      menu,
    };
  },
  methods: {
    login() {
      this.$http
        .post(this.$store.state.base_url + "/login", {
          account: this.username,
          password: this.password,
        })
        .then((res) => {
          if (res.data.status == 1) {
            userinfo.set(res.data.data);
            this.$message.info(res.data.msg);
            this.userinfo = userinfo.get();
            this.$isLogin = true;
          }
        });
    },
    logout() {
      userinfo.remove();
      this.$isLogin = false;
      this.userinfo = null;
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
      this.$message.info("退出登录");
    },
  },
  mounted() {
    // this.$http
    //   .get("http://api.shipxy.com/apicall/QueryShip", {
    //     params: { v: this.k, k: this.k, enc: "1", kw: this.kw }
    //   })
    //   .then(res => {
    //     this.$http
    //       .get("http://api.shipxy.com/apicall/GetSingleShip", {
    //         params: {
    //           v: this.v,
    //           k: this.k,
    //           enc: "1",
    //           id: res.data.data[0].ShipID
    //         }
    //       })
    //       .then(r => {
    //         console.log(r.data);
    //       });
    //   });
    this.islogin = this.$isLogin;
    if (userinfo.get() == null) {
      return;
    } else {
      this.$http
        .post(this.$store.state.base_url + "/check_token", {
          access_token: userinfo.get().access_token,
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.$isLogin = true;
          }
        });
    }
  },
  watch: {
    $isLogin: {
      handler() {
        this.islogin = this.$isLogin;
      },
      deep: true,
    },
  },
};
</script>

<style>
* {
  font-family: "rockwell";
}

.logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}

.login_form {
  width: 300px;
  display: block;
  margin: 100px auto 0px auto !important;
}

.login_form_logo {
  width: 300px;
  display: block;
  margin: 10px auto;
}

.login_form_title {
  display: block;
  margin: 10px auto;
  text-align: center;
}

.login-form-button {
  width: 100%;
}

.ant-table-thead tr th div {
  text-align: center;
}
</style>
